import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded'
import {
  Badge,
  Chip,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Menu,
  Stack,
  Typography,
} from '@mui/material'
import { useState, type MouseEvent } from 'react'

import { useNotifications } from '@/features/notifications/useNotifications'
import { SEVERITY_LABEL } from '@/utils/statusLabels'

const SEVERITY_COLOR: Record<string, 'default' | 'warning' | 'error'> = {
  low: 'default',
  medium: 'default',
  high: 'warning',
  critical: 'error',
}

export function NotificationsBell() {
  const { items, unreadCount, isConnected, markAllRead } = useNotifications()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    markAllRead()
  }

  return (
    <>
      <IconButton onClick={handleOpen} aria-label="Notificaciones">
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsRoundedIcon />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { width: 340, maxHeight: 420, mt: 1 } } }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 2, py: 1.5 }}>
          <Typography variant="subtitle2">Alertas en tiempo real</Typography>
          <Chip
            size="small"
            label={isConnected ? 'Conectado' : 'Reconectando…'}
            color={isConnected ? 'success' : 'default'}
            variant="outlined"
          />
        </Stack>
        <Divider />
        {items.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ px: 2, py: 3, textAlign: 'center' }}>
            Sin alertas nuevas.
          </Typography>
        ) : (
          <List dense sx={{ py: 0 }}>
            {items.map((item) => (
              <ListItem key={item.id} divider>
                <ListItemText
                  primary={
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Chip
                        size="small"
                        label={SEVERITY_LABEL[item.severity] ?? item.severity}
                        color={SEVERITY_COLOR[item.severity] ?? 'default'}
                      />
                      <Typography variant="body2">{item.title}</Typography>
                    </Stack>
                  }
                  secondary={new Date(item.createdAt).toLocaleString('es-MX')}
                />
              </ListItem>
            ))}
          </List>
        )}
      </Menu>
    </>
  )
}
